<template>
  <div class="wallet-page">
    <div class="wallet-body">
      <div class="wallet-top">
        <div class="wallet-top__left">
          <div class="user">
            <UserAvatar :size="70" />
            <img
              v-if="avatarFrameSrc"
              :src="avatarFrameSrc"
              alt=""
              class="avatar_out"
            />
          </div>
          <div class="info">
            <div class="username">{{ displayName }}</div>
            <div class="id">{{ displayId }}</div>
          </div>
        </div>
        <div class="wallet-top__right">
          <div class="select_choose">
            <div
              class="item"
              :class="{ 'item--active': type === 1 }"
              @click="changeSelect(1)"
            >
              货币钱包
            </div>
            <div
              class="item"
              :class="{ 'item--active': type === 2 }"
              @click="changeSelect(2)"
            >
              数字钱包
            </div>
          </div>
        </div>
      </div>
      <div class="wallet-main">
        <currencyWallet v-if="type === 1" />
        <digitalWallet v-else />
      </div>
    </div>
  </div>
</template>
<script setup>
import currencyWallet from "./components/currencyWallet.vue";
import digitalWallet from "./components/digitalWallet.vue";
import UserAvatar from "@/components/UserAvatar.vue";
import { ref, computed, onMounted } from "vue";
import { useUserStore } from "@/stores/user";

const userStore = useUserStore();
const type = ref(1);

const displayName = computed(
  () => userStore.userInfo?.username || "未设置昵称"
);

const displayId = computed(() => {
  const info = userStore.userInfo;
  if (info?.phone) return info.phone;
  if (info?.id) return `ID: ${info.id}`;
  return "";
});

const avatarFrameSrc = computed(() => userStore.userInfo?.iconFrame || "");

const changeSelect = (i) => {
  type.value = i;
};

onMounted(() => {
  if (userStore.token && !userStore.userInfo?.username) {
    userStore.getUser();
  }
});
</script>
<style lang="scss" scoped>
/* 与订单 / IP 商城一致：86px 顶栏留白 + 左右 240 */
.wallet-page {
  min-height: 100vh;
  padding: 86px 240px 96px;
  background-color: transparent;
  font-family: var(--ios-font, inherit);
}

.wallet-body {
  width: 100%;
  padding-top: 36px;
}

.wallet-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 40px;
}

.wallet-top__left {
  display: flex;
  align-items: center;

  .user {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    margin-right: 14px;
    position: relative;
    overflow: visible;
    display: flex;
    align-items: center;
    justify-content: center;

    :deep(.user-avatar) {
      position: relative;
      z-index: 1;
    }

    .avatar_out {
      width: 85px;
      height: 85px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      object-fit: cover;
      display: block;
      pointer-events: none;
      z-index: 2;
    }
  }

  .info {
    .username {
      font-weight: 400;
      font-size: 20px;
      color: var(--ux-text-primary);
      line-height: 23px;
      letter-spacing: 3px;
    }

    .id {
      margin-top: 4px;
      font-weight: 400;
      font-size: 16px;
      color: var(--ux-text-secondary, #9fb4d6);
      line-height: 19px;
    }
  }
}

.wallet-top__right {
  .select_choose {
    display: flex;
    gap: 16px;

    .item {
      width: 159px;
      height: 46px;
      line-height: 46px;
      border-radius: var(--ios-radius-md, 14px);
      background: var(--ux-glass-bg-subtle);
      border: 0.5px solid var(--ux-glass-border);
      backdrop-filter: var(--ios-glass-blur-light);
      -webkit-backdrop-filter: var(--ios-glass-blur-light);
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      color: var(--ux-text-primary);
      cursor: pointer;
      transition: background 0.2s ease, border-color 0.2s ease,
        box-shadow 0.2s ease;
    }

    .item--active {
      color: #fff;
      font-weight: 600;
      border-color: transparent;
      background: linear-gradient(
        135deg,
        var(--ux-accent, #00d4ff) 0%,
        var(--ux-accent-2, #a78bfa) 100%
      );
      box-shadow: 0 0 16px var(--ux-accent-soft, rgba(0, 212, 255, 0.35));
    }
  }
}

.wallet-main {
  width: 100%;
}

@media (max-width: 1200px) {
  .wallet-page {
    padding-left: 48px;
    padding-right: 48px;
  }
}

@media (max-width: 768px) {
  .wallet-page {
    padding: 86px 20px 64px;
  }

  .wallet-top {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 28px;
  }

  .wallet-top__right .select_choose {
    justify-content: center;
  }
}
</style>
